export default {
  empresaID: null,
  responsavelID: null,
  situacao: null,
  secaoRHID: null,
  inicioObra: null,
  terminoObra: null,
  clienteRHID: null,
  obraRHID: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/employeeboardsearchmodel.js